import type { AnyObject } from '@/common';
import jsonata from 'jsonata';

import type { IEntity } from '../../../types';

export const transform = async (context: AnyObject, entity: IEntity, expression: string) => {
  const transfomer = jsonata(expression);

  const transformerPayload = {
    context,
    entity,
  };

  const transformResult = await transfomer.evaluate(transformerPayload);

  return transformResult;
};
